(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kymera-contact-actions"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('kymera-contact-actions'))customElements.define('kymera-contact-actions',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;
    this.refresh=()=>{
      const calculator=document.querySelector('kymera-area-calculator[data-product-page="true"]');
      const root=calculator?.closest('.kdp');
      const example=root?.dataset.paymentReview==='true';
      let client=null;
      if(!example)try{const q=JSON.parse(sessionStorage.getItem('kymeraQuote')||'null');if(q&&Date.now()-q.created<3600000)client=q;}catch{}
      const amounts=calculator?.contactQuote;
      const calc=calculator?.quoteCalculation;
      const money=cents=>new Intl.NumberFormat('en-EG',{style:'currency',currency:'EGP',maximumFractionDigits:2}).format(cents/100);
      const lines=['Hello Kymera, I would like to speak with a designer about this offer.',''];
      const add=(label,value)=>{if(value!==null&&value!==undefined&&String(value).trim()!=='')lines.push(label+': '+String(value).trim());};
      if(example)lines.push('LAYOUT PREVIEW EXAMPLE — not a submitted client quote.','');
      if(client){
        lines.push('CLIENT DETAILS');
        add('Name',client.name);add('Phone',client.phone);add('Email',client.email);
        add('Project city',client.projectCity);add('Area / district',client.projectDistrict);add('Project address',client.projectAddress);
        lines.push('','PROJECT DETAILS');
        add('Project type',client.projectTypeDetails||calculator?.querySelector('[data-type] option:checked')?.textContent||client.type);
        add('Interior area (m²)',client.area);add('Outdoor area (m²)',client.outdoor);add('Facade design',client.facadeEnabled?'Included as an add-on':'Not selected');add('Project brief',client.projectBrief);
        add('Quote reference',client.created);
      }
      if(amounts&&calc){
        lines.push('','OFFER & PAYMENT CHOICE');
        add('Package',this.dataset.productTitle);
        add('Payment choice',amounts.plan==='stages'?'Design milestones':amounts.plan==='monthly'?'Monthly installments on the discounted full design fee':'Full payment with 10% discount');
        add('Total design fee including VAT',money(amounts.total));
        add('Full payment price including VAT (after 10% discount)',money(amounts.discounted));
        add('Full payment saving',money(amounts.saving));
        add('Amount for selected payment choice',money(amounts.plan==='stages'?amounts.deposit:amounts.discounted));
        add('VAT rate',calc.vatRate+'%');
        add('First milestone including VAT',money(amounts.deposit));
        add('After design concept including VAT',money(amounts.second));
        add('After 3D design including VAT',money(amounts.third));
        add('Construction drawings','Included; no additional design installment');
        add('Illustrative installment term',amounts.months+' months');
        add('Estimated monthly payment',money((amounts.plan==='stages'?amounts.deposit:amounts.discounted)/amounts.months));
        lines.push('Final installment terms, fees and total repayment depend on the app/bank and plan selected at checkout.');
        if(example)add('Example project','Apartment, 200 m² interior');
        add('Pricing version',calc.version);
      }else if(client?.pricing){
        lines.push('','OFFER');
        add('Quote status',client.pricing.status);
        if(client.pricing.currency){
          add('Total including VAT',money(client.pricing.totalIncludingVAT*100));
          add('Full payment before VAT',money(client.pricing.fullPaymentBeforeVAT*100));
          add('First milestone before VAT',money(client.pricing.firstMilestoneBeforeVAT*100));
        }
      }else add('Package',this.dataset.productTitle);
      lines.push('');
      add('Page',new URL(this.dataset.productUrl||location.pathname,location.origin).href);
      lines.push('','Could you help me with this offer and the available payment options?');
      this.querySelector('[data-quote-whatsapp]').href='https://wa.me/201010060499?text='+encodeURIComponent(lines.join('\n'));
    };
    this.refresh();
    this.querySelector('[data-quote-whatsapp]').addEventListener('pointerdown',this.refresh);
    this.querySelector('[data-quote-whatsapp]').addEventListener('focus',this.refresh);
    document.addEventListener('kymera:quote-update',this.refresh);
    document.addEventListener('change',this.refresh);
    customElements.whenDefined('kymera-area-calculator').then(()=>this.isConnected&&this.refresh());
  }
  disconnectedCallback(){document.removeEventListener('kymera:quote-update',this.refresh);document.removeEventListener('change',this.refresh);}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kymera-design-product"] && !Shopify.designMode) return;
  try {
    customElements.whenDefined('kymera-area-calculator').then(()=>{
  document.querySelectorAll('.kdp').forEach(root=>{
    if (!root.dataset.inlineTermsReady) {
      root.dataset.inlineTermsReady = 'true';
      root.addEventListener('click', event => {
        const link = event.target.closest?.('[data-kdp-terms-link]');
        if (!link || !root.contains(link)) return;
        const terms = document.getElementById(link.hash.slice(1));
        if (!terms || !root.contains(terms) || !terms.matches('details[data-kdp-terms]')) return;
        event.preventDefault();
        terms.open = true;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        terms.scrollIntoView({behavior: reduceMotion ? 'auto' : 'smooth', block: 'start'});
        terms.querySelector('summary')?.focus({preventScroll: true});
      });
    }
    const calc=root.querySelector('kymera-area-calculator');
    if(!calc)return;
    let quote;try{quote=JSON.parse(sessionStorage.getItem('kymeraQuote')||'null');}catch{}
    const review=root.dataset.paymentReview==='true';
    const valid=review||quote&&Date.now()-quote.created<3600000&&quote.type&&quote.type!=='compound'&&quote.type!=='other'&&quote.name&&quote.email&&quote.phone;
    root.querySelector('[data-quote-missing]').hidden=Boolean(valid);
    if(!valid){root.querySelector('.kdp-order').hidden=true;return;}
    if(review){calc.dataset.paymentReview='true';calc.querySelector('[data-type]').value='apartment';calc.querySelector('[data-area]').value='200';calc.querySelector('[data-outdoor]').value='0';calc.querySelector('[data-type]').dispatchEvent(new Event('change',{bubbles:true}));}
    const plan=calc.querySelector('[data-plan]');
    const checkout=calc.querySelector('[data-checkout]');
    const refresh=()=>{
      for(const button of root.querySelectorAll('[data-kdp-plan]'))button.setAttribute('aria-pressed',String(button.dataset.kdpPlan===plan.value));
      checkout.textContent=plan.value==='stages'?root.dataset.stageLabel:plan.value==='monthly'?root.dataset.monthlyLabel:root.dataset.fullLabel;
      checkout.disabled=review;
    };
    for(const button of root.querySelectorAll('[data-kdp-plan]'))button.addEventListener('click',()=>{plan.value=button.dataset.kdpPlan;plan.dispatchEvent(new Event('change',{bubbles:true}));refresh();});
    if(!review&&Number(quote.area||0)===0)calc.querySelector('[data-interior-fee]').closest('p').hidden=true;
    if(!review&&Number(quote.outdoor||0)===0)calc.querySelector('[data-outdoor-fee]').closest('p').hidden=true;
    refresh();
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kymera-milestone-summary"] && !Shopify.designMode) return;
  try {
    const setupKymeraLimitedDeal=()=>{
  document.querySelectorAll('[data-limited-deal]').forEach(box=>{
    if(box.dataset.timerReady==='1') return;
    box.dataset.timerReady='1';
    const out=box.querySelector('[data-limited-countdown]');
    if(!out) return;
    const key='kymeraLimitedDealEndsAtV1';
    let end=0;
    try{end=Number(localStorage.getItem(key)||0);}catch(e){}
    const now=Date.now();
    if(!end||end<=now){end=now+48*60*60*1000;try{localStorage.setItem(key,String(end));}catch(e){}}
    const render=()=>{
      const left=Math.max(0,end-Date.now());
      const total=Math.floor(left/1000);
      const h=Math.floor(total/3600);
      const m=Math.floor((total%3600)/60);
      const s=total%60;
      out.textContent=String(h).padStart(2,'0')+':'+String(m).padStart(2,'0')+':'+String(s).padStart(2,'0');
    };
    render();
    const timer=setInterval(()=>{render();if(Date.now()>=end)clearInterval(timer);},1000);
  });
};
setupKymeraLimitedDeal();
document.addEventListener('shopify:section:load',setupKymeraLimitedDeal);

if (!customElements.get('kymera-display-currency')) {
  customElements.define('kymera-display-currency', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.currency = 'EGP';
      this.rates = {EGP: 1};
      this.select = this.querySelector('select');
      this.userChanged = false;
      this.countryCurrencies = {};
      try {
        const countries = JSON.parse(this.dataset.countryCodes || '[]');
        const currencies = JSON.parse(this.dataset.countryCurrencies || '[]');
        countries.forEach((country, index) => {
          const currency = currencies[index];
          if (!/^[A-Z]{3}$/.test(currency || '')) return;
          this.countryCurrencies[country] = currency;
          if (![...this.select.options].some(option => option.value === currency)) {
            const option = document.createElement('option');
            option.value = currency;
            this.select.append(option);
          }
        });
      } catch {}
      const names = new Intl.DisplayNames([this.lang || 'en'], {type: 'currency'});
      for (const option of this.select.options) {
        option.textContent = option.value + ' · ' + names.of(option.value);
      }
      this.select.addEventListener('change', async () => {
        this.userChanged = true;
        const wanted = this.select.value;
        try {
          if (wanted !== 'EGP') await this.loadRates();
          this.activate(wanted);
          try { localStorage.setItem('kymeraDisplayCurrency', this.currency); } catch {}
        } catch {
          this.activate('EGP');
        }
      });
      this.activate('EGP');
      this.initialize();
    }

    countryCurrency(country) {
      const map = {
        EG:'EGP', SA:'SAR', US:'USD', AE:'AED', GB:'GBP', CA:'CAD', AU:'AUD',
        KW:'KWD', QA:'QAR', BH:'BHD', OM:'OMR', CH:'CHF', LI:'CHF',
        SE:'SEK', NO:'NOK', DK:'DKK', NZ:'NZD', JO:'JOD', DE:'EUR', FR:'EUR',
        IT:'EUR', ES:'EUR', PT:'EUR', NL:'EUR', BE:'EUR', AT:'EUR', IE:'EUR',
        FI:'EUR', GR:'EUR', CY:'EUR', MT:'EUR', LU:'EUR', SK:'EUR', SI:'EUR',
        EE:'EUR', LV:'EUR', LT:'EUR', HR:'EUR', BG:'EUR'
      };
      return this.countryCurrencies[country] || map[country] || 'USD';
    }

    async fetchJSON(url) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 5000);
      try {
        const response = await fetch(url, {signal: controller.signal});
        if (!response.ok) throw new Error('Currency lookup unavailable');
        return await response.json();
      } finally {
        clearTimeout(timer);
      }
    }

    async initialize() {
      let preferred;
      try { preferred = localStorage.getItem('kymeraDisplayCurrency'); } catch {}
      const available = [...this.select.options].map(option => option.value);
      if (!available.includes(preferred)) preferred = null;
      let country = this.dataset.country || 'EG';
      if (!preferred) {
        try {
          const root = window.Shopify?.routes?.root || '/';
          const result = await this.fetchJSON(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false');
          country = result.detected_values?.country?.handle || country;
        } catch {}
      }
      if (this.userChanged) return;
      const wanted = preferred || this.countryCurrency(country);
      try {
        if (wanted !== 'EGP') await this.loadRates();
        if (!this.userChanged) this.activate(wanted);
      } catch {
        if (!this.userChanged) {
          this.activate('EGP');
        }
      }
    }

    async loadRates() {
      if (this.rateDate) return;
      if (this.ratePromise) return this.ratePromise;
      this.ratePromise = (async () => {
        let payload;
        try {
          const cache = JSON.parse(localStorage.getItem('kymeraDisplayRates') || 'null');
          if (cache && Date.now() - cache.saved < 86400000) payload = cache.payload;
        } catch {}
        if (!payload) {
          payload = await this.fetchJSON('https://open.er-api.com/v6/latest/EGP');
        }
        const age = Date.now() - Number(payload.time_last_update_unix) * 1000;
        if (payload.result !== 'success' || payload.base_code !== 'EGP' ||
            !Number.isFinite(age) || age < -3600000 || age > 259200000 ||
            !payload.rates || Number(payload.rates.EGP) !== 1) {
          throw new Error('Invalid exchange rates');
        }
        this.rates = payload.rates;
        this.rateDate = new Date(Number(payload.time_last_update_unix) * 1000);
        try {
          localStorage.setItem('kymeraDisplayRates', JSON.stringify({saved: Date.now(), payload}));
        } catch {}
        for (const option of this.select.options) {
          option.disabled = !(Number.isFinite(this.rates[option.value]) && this.rates[option.value] > 0);
        }
      })();
      try { await this.ratePromise; } finally { this.ratePromise = null; }
    }

    activate(currency) {
      if (!(Number.isFinite(this.rates[currency]) && this.rates[currency] > 0)) currency = 'EGP';
      this.currency = currency;
      this.select.value = currency;
      this.formatter = new Intl.NumberFormat(this.lang || 'en', {
        style: 'currency', currency, currencyDisplay: 'code',
        minimumFractionDigits: 0, maximumFractionDigits: 0
      });
      this.dispatchEvent(new CustomEvent('kymera:display-currency-change', {bubbles:true}));
    }

    format(amountEGP) {
      return this.formatter.format(amountEGP * this.rates[this.currency]);
    }
  });
}

if (!customElements.get('kymera-area-calculator')) {
  customElements.define('kymera-area-calculator', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      const area = this.querySelector('[data-area]');
      const outdoor = this.querySelector('[data-outdoor]');
      const facadeEnabled = this.querySelector('[data-facade-enabled]');
      const rows = [];
      const plan = this.querySelector('[data-plan]');
      const type = this.querySelector('[data-type]');
      const isProduct = this.dataset.productPage === 'true';
      const contact = this.querySelector('[data-contact-fields]');
      const next = this.querySelector('[data-continue]');
      const planLabel = this.querySelector('label[for^="KymeraPlan"]');
      const phone = this.querySelector('[data-phone]');
      const country = this.querySelector('[data-phone-country]');
      const otherDial = this.querySelector('[data-other-dial]');

      const names = new Intl.DisplayNames(
        [this.lang === 'ar' ? 'ar' : 'en'],
        {type: 'region'}
      );

      const countries = [
        ['SA','966'], ['AE','971'], ['KW','965'], ['QA','974'],
        ['BH','973'], ['OM','968'], ['US','1'], ['CA','1'],
        ['GB','44'], ['DE','49'], ['FR','33'], ['IT','39'],
        ['ES','34'], ['AU','61'], ['TR','90'], ['JO','962'],
        ['LB','961'], ['MA','212'], ['ZA','27'], ['IN','91'],
        ['CN','86']
      ];

      for (const [iso, dial] of countries) {
        const option = document.createElement('option');
        option.value = '+' + dial;
        option.dataset.iso = iso;
        option.textContent =
          String.fromCodePoint(...[...iso].map(c => 127397 + c.charCodeAt())) +
          ' ' + names.of(iso) + ' (+' + dial + ')';
        country.append(option);
      }

      const otherOption = document.createElement('option');
      otherOption.value = 'other';
      otherOption.textContent = country.dataset.otherLabel;
      country.append(otherOption);

      const normalizePhone = () => {
        const raw = phone.value.trim().replace(/[() .-]/g, '');
        if (raw.startsWith('+')) return raw;
        const prefix = country.value === 'other'
          ? '+' + otherDial.value.replace(/[^0-9]/g, '')
          : country.value;
        const local = country.value === '+39' ? raw : raw.replace(/^0+/, '');
        return prefix + local;
      };

      const syncPhone = () => {
        const custom = country.value === 'other';
        this.querySelector('[data-other-code-field]').hidden = !custom;
        otherDial.disabled = !custom;
        const complete = normalizePhone();
        this.querySelector('[data-full-phone]').value = complete;
        phone.setCustomValidity(
          phone.value.trim() && !/^\+[1-9][0-9]{6,14}$/.test(complete)
            ? this.lang === 'ar'
              ? 'اكتب رقم الموبايل صحيحًا شامل كود البلد.'
              : 'Enter a valid phone number with its country code.'
            : ''
        );
      };

      country.addEventListener('change', syncPhone);
      phone.addEventListener('input', syncPhone);
      otherDial.addEventListener('input', syncPhone);
      syncPhone();

      contact.hidden = isProduct;
      plan.hidden = !isProduct;
      planLabel.hidden = !isProduct;

      if (isProduct) {
        try {
          const q = JSON.parse(sessionStorage.getItem('kymeraQuote') || 'null');
          if (q && Date.now() - q.created < 3600000) {
            type.value = q.type;
            area.value = q.area;
            outdoor.value = q.outdoor;
            facadeEnabled.checked = q.facadeEnabled;
          }
        } catch {}
      }

      const money = new Intl.NumberFormat(this.lang || 'en', {
        style: 'currency',
        currency: 'EGP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });

      const currencyDisplay = this.querySelector('kymera-display-currency');
      const displayMoney = amount => currencyDisplay?.formatter
        ? currencyDisplay.format(amount)
        : money.format(amount);
      this.addEventListener('kymera:display-currency-change', () => update());

      const update = () => {
        const custom =
          type.value === 'compound' ||
          type.value === 'other' ||
          Number(area.value) > 1000 ||
          Number(outdoor.value) > 1000;

        this.isCustomQuote = custom;
        const landscapeOnly = type.value === 'landscape';
        const compoundOnly = type.value === 'compound' || type.value === 'other';

        this.querySelector('[data-other-project-field]').hidden = type.value !== 'other';
        this.querySelector('[data-other-project-type]').disabled = type.value !== 'other';
        this.querySelector('[data-outdoor-fields]').hidden = compoundOnly;
        outdoor.disabled = compoundOnly;
        if (compoundOnly) outdoor.value = '';

        this.querySelector('[data-extra-services]').hidden = custom;
        const standard = Boolean(type.value);

        this.querySelector('[data-custom-quote]').hidden = !custom;
        this.querySelector('[data-standard-fields]').hidden = !standard;
        this.querySelector('[data-interior-fields]').hidden = landscapeOnly;
        this.querySelector('[data-facade-fields]').hidden = landscapeOnly || custom;
        this.querySelector('[data-project-brief-fields]').hidden = !custom;
        this.querySelector('[data-talk-designer]').hidden = !custom;
        next.textContent = custom ? this.dataset.submitLabel : this.dataset.priceLabel;

        this.querySelector('label[for^="KymeraArea"]').textContent =
          custom ? this.dataset.projectAreaLabel : this.dataset.interiorAreaLabel;

        this.querySelector('[data-interior-help]').textContent =
          custom ? this.dataset.projectAreaHelp : this.dataset.interiorAreaHelp;

        const value = landscapeOnly ? 0 : Number(area.value);
        const outdoorValue = Number(outdoor.value);
        const enabled = facadeEnabled.checked && !landscapeOnly && !custom;

        this.querySelector('[data-facade-line]').hidden = !enabled;

        const valid =
          standard &&
          (landscapeOnly || area.checkValidity()) &&
          outdoor.checkValidity() &&
          Number.isFinite(value) &&
          Number.isFinite(outdoorValue) &&
          value + outdoorValue > 0 &&
          (!enabled || value > 0);

        this.areaValid = valid;
        this.querySelector('[data-results]').hidden = !valid || !isProduct || custom;
        if (!valid || custom) return;

        const interiorUnits = Math.round(value * 100);
        const outdoorUnits = Math.round(outdoorValue * 100);

        const pricing = {
          apartment: {rates: [1000, 900, 700], min: 100000},
          villa: {rates: [1200, 1000, 800], min: 240000},
          office: {rates: [1100, 950, 750], min: 110000},
          retail: {rates: [1500, 1300, 1000], min: 150000},
          restaurant: {rates: [1800, 1600, 1250], min: 180000}
        };

        const selected = pricing[type.value];

        const tiered = (units, rates) =>
          Math.min(units, 20000) * rates[0] +
          Math.max(0, Math.min(units - 20000, 30000)) * rates[1] +
          Math.max(0, units - 50000) * rates[2];

        const interiorFee =
          !landscapeOnly && interiorUnits > 0 && selected
            ? Math.max(tiered(interiorUnits, selected.rates), selected.min * 100)
            : 0;

        const outdoorFee =
          Math.min(outdoorUnits, 30000) * 50 +
          Math.max(0, outdoorUnits - 30000) * 50;

        const facadeFee = enabled ? Math.round(interiorFee * 0.2) : 0;
        const netTotal = interiorFee + outdoorFee + facadeFee;
        const vatRate = Number(this.dataset.vatRate);
        const vatVerified = this.dataset.vatVerified === 'true' && Number.isFinite(vatRate) && vatRate >= 0 && vatRate <= 100;
        const tax = amount => Math.round(amount * vatRate / 100);
        const total = netTotal + tax(netTotal);
        this.querySelector('[data-tax-pending]').hidden = vatVerified;
        this.querySelector('[data-results]').hidden = !isProduct || !vatVerified;
        if (!vatVerified) return;

        this.querySelector('[data-interior-fee]').textContent = displayMoney(interiorFee / 100);
        this.querySelector('[data-outdoor-fee]').textContent = displayMoney(outdoorFee / 100);
        this.querySelector('[data-facade-fee]').textContent = displayMoney(facadeFee / 100);

        this.quoteCalculation = {
          areas: [value, outdoorValue],
          facade: enabled,
          interiorFee,
          outdoorFee,
          facadeFee,
          total: netTotal,
          grossTotal: total,
          vatRate,
          version: '2026-11-01-approved-outdoor-50'
        };

        const netDiscounted = netTotal - Math.round(netTotal / 10);
        const discounted = netDiscounted + tax(netDiscounted);
        const saving = total - discounted;
        const netFirst = Math.round(netTotal / 2);
        const netSecond = Math.round(netTotal * 0.4);
        const first = netFirst + tax(netFirst);
        const second = netSecond + tax(netSecond);

        const amounts = {
          total,
          discounted,
          saving,
          deposit: first,
          second,
          third: total - first - second
        };

        for (const [key, cents] of Object.entries(amounts)) {
          this.querySelector('[data-' + key + ']').textContent = displayMoney(cents / 100);
        }

        this.querySelector('[data-base-total]').hidden = false;
        this.querySelector('[data-total]').classList.toggle(
          'kdp-total-struck',
          plan.value !== 'stages'
        );
        this.querySelector('[data-full]').hidden = plan.value === 'stages';
        this.querySelector('[data-stages]').hidden = plan.value !== 'stages';
        const monthlyMonths = this.querySelector('[data-monthly-months]');
        const months = Number(monthlyMonths?.value || 60);
        this.contactQuote = {...amounts, plan: plan.value, months};
        this.dispatchEvent(new CustomEvent('kymera:quote-update',{bubbles:true,detail:this.contactQuote}));
        const financeAmount = plan.value === 'stages' ? first : discounted;
        const monthlyAmount = this.querySelector('[data-monthly-amount]');
        if (monthlyAmount) monthlyAmount.textContent = displayMoney(financeAmount / 100 / months);
        const root = this.closest('.kdp');
        if(root)for(const [choice,amount] of Object.entries({full:discounted,stages:first,monthly:discounted / months})){
          const label=root.querySelector('[data-kdp-price="'+choice+'"]');
          if(label)label.textContent=displayMoney(amount / 100);
        }
      };

      const checkout = this.querySelector('[data-checkout]');

      checkout.addEventListener('click', async () => {
        update();

        if (!isProduct || !this.areaValid || this.isCustomQuote || checkout.disabled || this.dataset.paymentReview === 'true') return;

        const terms = this.querySelector('[data-accept-terms]');
        if (terms && !terms.checked) {
          terms.reportValidity();
          return;
        }

        let q;
        try {
          q = JSON.parse(sessionStorage.getItem('kymeraQuote') || 'null');
        } catch {}

        if (
          !q ||
          Date.now() - q.created >= 3600000 ||
          !q.name ||
          !q.email ||
          !q.phone
        ) {
          const quoteUrl = new URL((window.Shopify?.routes?.root || '/') + 'pages/get-quote', location.origin);
          const previewTheme = new URLSearchParams(location.search).get('preview_theme_id');
          if (previewTheme) quoteUrl.searchParams.set('preview_theme_id', previewTheme);
          location.assign(quoteUrl.href);
          return;
        }

        checkout.disabled = true;
        const error = this.querySelector('[data-checkout-error]');
        error.hidden = true;
        const root = window.Shopify?.routes?.root || '/';

        const request = async (path, body) => {
          const r = await fetch(root + path, {
            method: body ? 'POST' : 'GET',
            headers: {'Content-Type': 'application/json'},
            ...(body ? {body: JSON.stringify(body)} : {})
          });
          const json = await r.json();
          if (!r.ok) throw new Error('Cart request failed');
          return json;
        };

        try {
          const variants = [
            42853791531090,
            42853791563858,
            42853791596626,
            42853791629394
          ];

          const stage = plan.value === 'stages';
          const calc = this.quoteCalculation;
          const quoteId = String(q.created);
          const expected = stage
            ? Math.round(calc.total / 2)
            : calc.total - Math.round(calc.total / 10);

          const original = await request('cart.js');
          const updates = {};

          for (const line of original.items) {
            if (line.properties?._kymera_quote) updates[line.key] = 0;
          }

          if (Object.keys(updates).length) {
            await request('cart/update.js', {updates});
          }

          const quantities = [Math.floor(expected / 1000), expected % 1000];

          const items = quantities.map((quantity, i) => ({
            id: variants[i * 2 + (stage ? 1 : 0)],
            quantity,
            properties: {
              _kymera_quote: quoteId,
              _pricing_version: calc.version,
              'Project type': q.type,
              'Interior area (m²)': String(calc.areas[0]),
              'Outdoor area (m²)': String(calc.areas[1]),
              'Facade add-on': calc.facade
                ? '20% of interior design fee'
                : 'Not selected',
              'Quantity unit': i === 0
                ? 'EGP 10 of quoted design fee'
                : 'EGP 0.01 of quoted design fee',
              'Payment': stage
                ? 'First milestone: 50%; remaining 40% and 10% collected separately'
                : 'Full payment: 10% saving included',
              'Contract total before VAT': money.format(calc.total / 100),
              _client_name: q.name,
              _client_phone: q.phone,
              _client_email: q.email,
              'Project city': q.projectCity || '',
              'Project district': q.projectDistrict || '',
              'Project address': q.projectAddress || ''
            }
          })).filter(item => item.quantity > 0);

          if (items.some(item => item.quantity > 999999)) {
            throw new Error('Area too large');
          }

          await request('cart/add.js', {items});

          await request('cart/update.js', {
            attributes: {
              'Client name': q.name,
              'Client phone': q.phone,
              'Client email': q.email,
              'Project city': q.projectCity || '',
              'Project district': q.projectDistrict || '',
              'Project address': q.projectAddress || '',
              'Project type': q.type,
              'Contract value before VAT': money.format(calc.total / 100),
              'Payment plan': stage
                ? '50% now, 40% second milestone, 10% final milestone'
                : 'Full payment with 10% saving',
              'Design terms accepted': terms?.checked ? 'Yes' : 'Not recorded'
            }
          });

          const cart = await request('cart.js');
          const lines = cart.items.filter(
            line => line.properties?._kymera_quote === quoteId
          );

          if (
            lines.length !== items.length ||
            lines.reduce((sum, line) => sum + line.final_line_price, 0) !== expected
          ) {
            throw new Error('Checkout amount mismatch');
          }

          const url = new URL(root + 'checkout', location.origin);
          url.searchParams.set('checkout[email]', q.email);
          url.searchParams.set('checkout[billing_address][phone]', q.phone);
          location.assign(url.href);
        } catch {
          error.hidden = false;
          checkout.disabled = false;
        }
      });

      const leadForm = this.closest('form[action*="/contact"]');

      if (leadForm) {
        leadForm.addEventListener('submit', event => {
          if (leadForm.dataset.quoteReady !== 'true') {
            event.preventDefault();
            next.click();
          }
        });
      }

      next.addEventListener('click', () => {
        update();
        syncPhone();

        const inputs = [
          ...contact.querySelectorAll('input, textarea'),
          this.querySelector('[data-other-project-type]')
        ];

        const invalid = inputs.find(input =>
          !input.disabled &&
          input.type !== 'hidden' &&
          (
            (input.required && !input.value.trim()) ||
            !input.checkValidity()
          )
        );

        if (!this.areaValid || invalid) {
          this.querySelector('[data-flow-error]').hidden = false;
          if (invalid) invalid.reportValidity();
          return;
        }

        const q = {
          created: Date.now(),
          type: type.value,
          projectTypeDetails: type.value === 'other'
            ? this.querySelector('[data-other-project-type]').value.trim()
            : '',
          area: area.value,
          outdoor: type.value === 'compound' || type.value === 'other'
            ? '0'
            : outdoor.value,
          facadeEnabled: type.value === 'compound' || type.value === 'other'
            ? false
            : facadeEnabled.checked,
          facades: rows.map(row => ({
            width: row.querySelector('[data-width]').value,
            height: row.querySelector('[data-height]').value
          })),
          name: contact.querySelector('[data-name]').value.trim(),
          phone: normalizePhone(),
          phoneCountry: country.selectedOptions[0].textContent,
          email: contact.querySelector('[data-email]').value.trim(),
          projectCity: contact.querySelector('[data-project-city]').value.trim(),
          projectDistrict: contact.querySelector('[data-project-district]').value.trim(),
          projectAddress: contact.querySelector('[data-project-address]').value.trim(),
          projectBrief: contact.querySelector('[data-project-brief]').value.trim()
        };

        if (!this.isCustomQuote && this.quoteCalculation) {
          const calc = this.quoteCalculation;
          const saving = Math.round(calc.total / 10);
          const first = Math.round(calc.total / 2);
          const second = Math.round(calc.total * 0.4);

          q.pricing = {
            status: 'Calculated quote; payment choice not yet selected',
            currency: 'EGP',
            tax: 'Displayed totals include applicable VAT; net fee fields are labelled before VAT',
            vatRate: calc.vatRate,
            totalIncludingVAT: calc.grossTotal / 100,
            interiorDesign: calc.interiorFee / 100,
            outdoorDesign: calc.outdoorFee / 100,
            facadeDesign: calc.facadeFee / 100,
            totalBeforeVAT: calc.total / 100,
            fullPaymentDiscount: saving / 100,
            fullPaymentBeforeVAT: (calc.total - saving) / 100,
            firstMilestoneBeforeVAT: first / 100,
            secondMilestoneBeforeVAT: second / 100,
            finalMilestoneBeforeVAT: (calc.total - first - second) / 100,
            pricingVersion: calc.version
          };
        } else {
          q.pricing = {
            status: 'Custom quote required; no automatic price'
          };
        }

        try {
          sessionStorage.setItem('kymeraQuote', JSON.stringify(q));
        } catch {
          this.querySelector('[data-flow-error]').hidden = false;
          return;
        }

        const url = new URL((window.Shopify?.routes?.root || '/') + 'products/kymera-design-package-200', location.origin);
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);

        const form = this.closest('form[action*="/contact"]');

        if (form) {
          const body = form.querySelector('[data-quote-lead-body]');
          body.value = JSON.stringify({
            source: 'Online design quote request before price',
            ...q
          });

          for (const old of form.querySelectorAll('[data-quote-price-field]')) {
            old.remove();
          }

          const priceFields = q.pricing.currency ? {
            'Quote status': q.pricing.status,
            'Interior design fee': money.format(q.pricing.interiorDesign),
            'Outdoor design fee': money.format(q.pricing.outdoorDesign),
            'Facade design fee': money.format(q.pricing.facadeDesign),
            'Total before VAT': money.format(q.pricing.totalBeforeVAT),
            'Full payment discount': money.format(q.pricing.fullPaymentDiscount),
            'Full payment price before VAT': money.format(q.pricing.fullPaymentBeforeVAT),
            'First milestone before VAT': money.format(q.pricing.firstMilestoneBeforeVAT),
            'Second milestone before VAT': money.format(q.pricing.secondMilestoneBeforeVAT),
            'Final milestone before VAT': money.format(q.pricing.finalMilestoneBeforeVAT),
            'Tax note': q.pricing.tax,
            'Pricing version': q.pricing.pricingVersion
          } : {
            'Quote status': q.pricing.status
          };

          for (const [label, value] of Object.entries(priceFields)) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'contact[' + label + ']';
            input.value = String(value);
            input.setAttribute('data-quote-price-field', '');
            form.append(input);
          }

          const custom =
            q.type === 'compound' ||
            q.type === 'other' ||
            Number(q.area) > 1000 ||
            Number(q.outdoor) > 1000;

          let returnTo = form.querySelector('input[name="return_to"]');

          if (!returnTo) {
            returnTo = document.createElement('input');
            returnTo.type = 'hidden';
            returnTo.name = 'return_to';
            form.append(returnTo);
          }

          const resultUrl = custom
            ? new URL((window.Shopify?.routes?.root || '/') + 'pages/get-quote?contact_posted=true#KymeraQuoteLead', location.origin)
            : url;
          if (preview) resultUrl.searchParams.set('preview_theme_id', preview);
          returnTo.value = resultUrl.pathname + resultUrl.search + resultUrl.hash;

          next.disabled = true;
          form.dataset.quoteReady = 'true';
          form.requestSubmit();
        } else {
          location.assign(url.href);
        }
      });

      this.addEventListener('input', update);
      facadeEnabled.addEventListener('change', update);
      plan.addEventListener('change', update);
      this.querySelector('[data-monthly-months]')?.addEventListener('change', update);
      type.addEventListener('change', update);

      const section = this.closest('section');

      if (section) {
        section.addEventListener('submit', event => {
          if (event.target.matches('form[action*="/cart/add"]')) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, true);
      }

      update();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kymera-offer-preview"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('kymera-offer-preview'))customElements.define('kymera-offer-preview',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;
    const key='kymera-campaign-preview-end:'+this.dataset.theme;
    try{this.end=Number(localStorage.getItem(key));if(!Number.isFinite(this.end)||this.end<=0){this.end=Date.now()+48*3600000;localStorage.setItem(key,String(this.end));}}catch{this.end=Date.now()+48*3600000;}
    this.tick=()=>{const left=Math.max(0,Math.floor((this.end-Date.now())/1000));for(const [field,value] of Object.entries({hours:Math.floor(left/3600),minutes:Math.floor(left/60)%60,seconds:left%60}))this.querySelector('[data-offer-'+field+']').textContent=String(value).padStart(2,'0');};
    this.tick();this.timer=setInterval(this.tick,1000);
  }
  disconnectedCallback(){clearInterval(this.timer);}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kymera-paylater-offer"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('kymera-paylater-offer'))customElements.define('kymera-paylater-offer',class extends HTMLElement{
  connectedCallback(){if(this.ready)return;this.ready=true;this.term=this.querySelector('[data-kpo-term]');this.term.addEventListener('change',()=>this.refresh());this.refresh();}
  setAmount(cents,formatter){this.dataset.amount=String(cents);this.formatter=formatter;this.refresh();}
  refresh(){const amount=Number(this.dataset.amount);if(!Number.isFinite(amount)||amount<=0)return;const term=Number(this.term?.value||60);const money=this.formatter||((value)=>new Intl.NumberFormat(this.lang||'en',{style:'currency',currency:this.dataset.currency||'EGP',maximumFractionDigits:0}).format(value));this.querySelector('[data-kpo-monthly]').textContent=money(Math.ceil(amount/term)/100);this.querySelector('[data-kpo-total]').textContent=money(amount/100);}
});
  } catch(e) { console.error(e); }
})();

})();
